<template>
    <div>
        <b-row v-if="images && images.length > 0">
            <b-col sm="9">
                <div>
                    <zoom-on-hover :img-normal="imgUrl(images[currentIndex])" :scale="1.5"></zoom-on-hover>
                <!-- <b-img :src="imgUrl(images[currentIndex])"
                       @click="openImage(images[currentIndex])"
                       class="img-link"
                       fluid>
                </b-img> -->
                </div>
            </b-col>

            <b-col align="center">
                <b-link v-for="(img, index) in images"
                        @click="viewImage(index)"
                        :key="index">
                <b-img width="125px;"
                       class="mr-2"
                       thumbnail
                       block
                       :src="imgUrl(img)">
                </b-img>
                </b-link>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        name: "ImagesZoom",
        props: [ 'images', 'hasFullUrl' ],
        data() {
            return {
                currentIndex: 0,
            }
        },
        methods: {
            imgUrl(img) {
                return this.hasFullUrl ? img.url : process.env.VUE_APP_IMAGES_URL + img.url;
            },
            viewImage(index) {
                this.currentIndex = index;
            },
            openImage(img) {
                window.open(this.imgUrl(img), 'imageViewer');
            }
        }
    }
</script>

<style scoped>
    .img-link:hover {
        cursor: pointer;
    }
</style>